/* Ark redesign: one shared, cached read of the public events gateway (Luma sync).
   The layout also inlines an hourly snapshot (#ark-rd-events-snapshot); it is used when the
   gateway is blocked or slow in a visitor's browser, so the next event never stays a skeleton. */
(function () {
  if (window.arkRdEvents) return;
  var cached;
  function snapshot() {
    try {
      var el = document.getElementById('ark-rd-events-snapshot');
      var d = el && JSON.parse(el.textContent);
      return d && Array.isArray(d.upcoming) ? d : null;
    } catch (e) { return null; }
  }
  window.arkRdEvents = function () {
    if (!cached) {
      var get = function () {
        var ctl = window.AbortController ? new AbortController() : null;
        var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 3500);
        return Promise.race([
          fetch('https://ark-events-gateway.jacky-7a9.workers.dev/v1/events', { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
            .then(function (r) { if (!r.ok) throw new Error('events ' + r.status); return r.json(); }),
          new Promise(function (ok, fail) { setTimeout(function () { fail(new Error('events timeout')); }, 3600); })
        ]).then(function (d) { clearTimeout(timer); return d; }, function (e) { clearTimeout(timer); throw e; });
      };
      var snap = snapshot();
      /* With a snapshot, fall back to it at once; without one, retry once after a short pause. */
      cached = get()
        .catch(function () { return snap || new Promise(function (ok) { setTimeout(ok, 1500); }).then(get); })
        .then(function (d) {
          var now = Date.now();
          var upcoming = (d.upcoming || []).filter(function (e) { return Date.parse(e.endsAt || e.startsAt) > now; })
            .sort(function (a, b) { return Date.parse(a.startsAt) - Date.parse(b.startsAt); });
          var past = (d.past || []).slice().sort(function (a, b) { return Date.parse(b.startsAt) - Date.parse(a.startsAt); });
          return { upcoming: upcoming, past: past };
        })
        .catch(function () { return { upcoming: [], past: [], error: true }; });
    }
    return cached;
  };
  /* Dates in the event's own timezone: {weekday:'Fri', month:'Oct', day:'16', date:'Fri, Oct 16', time:'11:00 PM – 2:30 AM'} */
  window.arkRdEventDate = function (e) {
    var tz = e.timezone || 'America/New_York';
    var fmt = function (d, o) { return new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: tz }, o)).format(d); };
    var s = new Date(e.startsAt), en = e.endsAt ? new Date(e.endsAt) : null, t = { hour: 'numeric', minute: '2-digit' };
    return { weekday: fmt(s, { weekday: 'short' }), month: fmt(s, { month: 'short' }), day: fmt(s, { day: 'numeric' }),
      date: fmt(s, { weekday: 'short', month: 'short', day: 'numeric' }), time: fmt(s, t) + (en ? ' – ' + fmt(en, t) : '') };
  };
})();
